import React, { Component } from 'react';
import './TablaTecno.css';
import { Link as RouterLink } from 'react-router-dom';
import { deleteCasoTecno, getCasosTecnoEquipo, editCasoTecno, clearErrors } from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Accordion, AccordionDetails, AccordionSummary, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField, Tooltip, IconButton, Typography, Grid } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaArrowLeft, FaCheck, FaEdit, FaTrashAlt } from 'react-icons/fa';
import moment from 'moment';

export class TablaTecno extends Component {

  constructor() {
    super();
    this.state = {
      testData: {},

      docId: "",

      // Información del paciente
      tipoIdentificacion: "",
      numeroIdentificacion: "",
      sexo: "",
      edad: "",
      edadEn: "",
      eps: "",
      diagnosticoInicialPaciente: "",

      // Información del equipo
      nombreGenericoDispositivo: "",
      nombreComercialDispositivo: "",
      RegistroSanitario_PermisoComercializacion: "",
      activoFijo: "", //Alpha ?
      lote: "",
      modelo: "",
      referencia: "",
      serie: "",
      marca: "",
      importadorDistribuidor: "",
      areaAccidente: "",
      servicio: "",
      ubicacion: "",
      masDeUnUso: "",

      // Descripcion del evento o incidente adverso
      fechaDelEvento: "",
      fechaReporte: "",
      momentoDeteccion: "",
      clasificacionCaso: "",
      descripcionCaso: "",
      desenlaceCaso: "",
      otro: "",

      // Gestión realizada
      causaCaso: "",
      accionTomada: "",
      reporteDistibuidor: "",
      fechaReporteDistribuidor: "",
      envioDistribuidor: "",
      fechaEnvioDistribuidor: "",
      disponibleEvaluacion: "",

      // Informacion del reportante
      nombreReportante: "",
      profesion: "",
      servicioPerteneciente: "",
      correoInstitucional: "",
      estadoReporte: "",

      errors: {},
      aprobado: {},
      openDetails: false,
      openEdit: false,
      openDelete: false,
    };
  };

  componentDidMount() {
    this.props.getCasosTecnoEquipo(this.props.equipoId);
  }

  handleOpenEdit = (data) => {
    this.setState({ openEdit: true, docId: data.id, errors: {}, aprobado: {} });
    const partes = data.areaAccidente.split('/')
    this.setState({

      tipoIdentificacion: data.tipoIdentificacion,
      numeroIdentificacion: data.numeroIdentificacion,
      sexo: data.sexo,
      edad: data.edad,
      edadEn: data.edadEn,
      eps: data.eps,
      diagnosticoInicialPaciente: data.diagnosticoInicialPaciente,

      nombreGenericoDispositivo: data.nombreGenericoDispositivo,
      nombreComercialDispositivo: data.nombreComercialDispositivo,
      RegistroSanitario_PermisoComercializacion: data.RegistroSanitario_PermisoComercializacion,
      activoFijo: data.activoFijo, //Alpha ?
      lote: data.lote,
      modelo: data.modelo,
      referencia: data.referencia,
      serie: data.serie,
      marca: data.marca,
      importadorDistribuidor: data.importadorDistribuidor,
      servicio: partes[0],
      ubicacion: partes[1],
      masDeUnUso: data.masDeUnUso,

      // Descripcion del evento o incidente adverso
      fechaDelEvento: moment(data.fechaDelEvento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      fechaReporte: moment(data.fechaReporte, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      momentoDeteccion: data.momentoDeteccion,
      clasificacionCaso: data.clasificacionCaso,
      descripcionCaso: data.descripcionCaso,
      desenlaceCaso: data.desenlaceCaso,
      otro: data.otro,

      causaCaso: data.causaCaso,
      accionTomada: data.accionTomada,
      reporteDistibuidor: data.reporteDistibuidor,
      fechaReporteDistribuidor: moment(data.fechaReporteDistribuidor, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      envioDistribuidor: data.envioDistribuidor,
      fechaEnvioDistribuidor: moment(data.fechaEnvioDistribuidor, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      disponibleEvaluacion: data.disponibleEvaluacion,

      //Informacion del reportante

      nombreReportante: this.props.usuario.nombre,
      profesion: this.props.usuario.tipouser,
      servicioPerteneciente: "",
      direccion: this.props.usuario.direccion,
      telefono: this.props.usuario.telefono,
      correoInstitucional: this.props.usuario.email,
      estadoReporte: data.estadoReporte
    });
  };

  handleEdit = () => {
    const reporte = {

      tipoIdentificacion: this.state.tipoIdentificacion,
      numeroIdentificacion: this.state.numeroIdentificacion,
      sexo: this.state.sexo,
      edad: this.state.edad,
      edadEn: this.state.edadEn,
      eps: this.state.eps,
      diagnosticoInicialPaciente: this.state.diagnosticoInicialPaciente,

      nombreComercialDispositivo: this.state.nombreComercialDispositivo,
      lote: this.state.lote,
      referencia: this.state.referencia,
      areaAccidente: this.state.servicio + "/" + this.state.ubicacion,
      masDeUnUso: this.state.masDeUnUso,

      // Descripcion del evento o incidente adverso
      fechaDelEvento: moment(this.state.fechaDelEvento).format('DD/MM/YYYY'),
      desenlaceCaso: this.state.desenlaceCaso,
      otro: this.state.otro,
      descripcionCaso: this.state.descripcionCaso,

      causaCaso: this.state.causaCaso,
      accionTomada: this.state.accionTomada,
      reporteDistibuidor: this.state.reporteDistibuidor,
      fechaReporteDistribuidor: moment(this.state.fechaReporteDistribuidor).format('DD/MM/YYYY'),
      envioDistribuidor: this.state.envioDistribuidor,
      fechaEnvioDistribuidor: moment(this.state.fechaEnvioDistribuidor).format('DD/MM/YYYY'),
      disponibleEvaluacion: this.state.disponibleEvaluacion,

      //Informacion del reportante
      nombreReportante: this.state.nombreReportante,
      profesion: this.state.profesion,
      direccion: this.state.direccion,
      telefono: this.state.telefono,
      servicioPerteneciente: this.state.servicioPerteneciente,
      correoInstitucional: this.state.correoInstitucional,
      estadoReporte: this.state.estadoReporte
    }
    console.log("Función editar caso")
    console.log(this.state.docId)
    this.props.editCasoTecno(reporte, this.state.docId)
  }

  handleCloseEdit = () => {
    this.props.clearErrors();
    this.setState({ openEdit: false, errors: {}, docId: "", aprobado: {} });
    this.setState({

      // Información del paciente
      tipoIdentificacion: "",
      numeroIdentificacion: "",
      sexo: "",
      edad: "",
      edadEn: "",
      eps: "",
      diagnosticoInicialPaciente: "",

      // Información del equipo
      nombreGenericoDispositivo: "",
      nombreComercialDispositivo: "",
      RegistroSanitario_PermisoComercializacion: "",
      activoFijo: "", //Alpha ?
      lote: "",
      modelo: "",
      referencia: "",
      serie: "",
      marca: "",
      importadorDistribuidor: "",
      areaAccidente: "",
      servicio: "",
      ubicacion: "",
      masDeUnUso: "",

      // Descripcion del evento o incidente adverso
      fechaDelEvento: "",
      fechaReporte: "",
      momentoDeteccion: "",
      clasificacionCaso: "",
      descripcionCaso: "",
      desenlaceCaso: "",
      otro: "",

      // Gestión realizada
      causaCaso: "",
      accionTomada: "",
      reporteDistibuidor: "",
      fechaReporteDistribuidor: "",
      envioDistribuidor: "",
      fechaEnvioDistribuidor: "",
      disponibleEvaluacion: "",

      // Informacion del reportante
      nombreReportante: "",
      profesion: "",
      servicioPerteneciente: "",
      correoInstitucional: "",
      estadoReporte: ""
    })
    this.state.aprobado.mensaje && (
      this.props.getCasosTecnoEquipo(this.props.equipoId)
    )
  };

  handleOpenDelete = (id) => {
    this.setState({ openDelete: true, docId: id, aprobado: {} });
  };

  handleDelete = () => {
    this.props.deleteCasoTecno(this.state.docId, this.props.equipoId)
  }

  handleCloseDelete = () => {
    this.setState({ openDelete: false, errors: {}, docId: "", aprobado: {} });
    this.state.aprobado.mensaje && (
      this.props.getCasosTecnoEquipo(this.props.equipoId)
    )
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

  render() {

    const { casostecnovigilancia, loadingtecno } = this.props.data;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

 const columns = [ {
        field: 'actions',
        headerName: 'Acciones',
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <Box>
            <Tooltip title="Ver reporte en PDF">
              <IconButton
                size="small"
                component={RouterLink}
                to={`/dashboard/casotecnovigilanciapdf/${this.props.clienteId}/${params.row.id}/${params.row.equipoId}`}
                onClick={(e) => e.stopPropagation()} // opcional: evita seleccionar la fila en DataGrid
              >
                <DescriptionIcon  />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar caso">
              <IconButton size="small" onClick={() => this.handleOpenEdit(params.row)}>
                <EditIcon  />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar Caso">
              <IconButton size="small" onClick={() => this.handleOpenDelete(params.row.id)}>
                <DeleteOutlineIcon  />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      { field: 'nombreReportante', headerName: 'último reportante', width: 200 },
      { field: 'clasificacionCaso', headerName: 'Clasificación', width: 180 },
      { field: 'fechaDelEvento', headerName: 'Fecha del evento', width: 150 },
      { field: 'fechaReporte', headerName: 'Fecha del reporte', width: 150 },
     
    ];

    const rows = casostecnovigilancia ? [...casostecnovigilancia].sort((a, b) => moment(b.fechaReporte, 'DD/MM/YYYY') - moment(a.fechaReporte, 'DD/MM/YYYY')) : [];

   let mapeoprogcals = !loadingtecno ? (
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        components={{
          Toolbar: () => (
            <Box p={1}>
              <GridToolbarQuickFilter placeholder="Buscar..." />
            </Box>
          )
        }}
        sx={{ height: 500, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}
      />
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 500 }}>
        <CircularProgress />
      </Box>
    );

    return (
      <Box className="listamtoprog-container" sx={{ width: '100%' }}>
             <Box className="listamtoprog-table" sx={{ mt: 1 }}>
            <Box sx={{ width: '100%' }}>
              <Typography sx={{ fontSize: '16px', color: '#03178C', fontWeight: 600 ,textAlign: 'center', mb: 1}}>
                          Casos de Tecnovigilancia
                        </Typography>
          
          {mapeoprogcals}
          
            </Box>
          
        </Box>

       
        <Dialog
          open={this.state.openDetails}
          onClose={this.handleCloseDetails}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
              Detalles del caso
            </Typography>
          </DialogTitle>
        </Dialog>


        <Dialog
          open={this.state.openEdit}
          onClose={this.handleCloseEdit}
          fullWidth
          maxWidth="sm"
        >
          {this.state.aprobado.mensaje ? (

            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado' />
              </div>
              <h2 className='text-aprobado'>¡Se ha registrado exitosamente el caso!</h2>

              {(this.state.clasificacionCaso == "Evento adverso serio" || this.state.clasificacionCaso == "Incidente adverso serio") &&
                <div className='mensaje_casos'>
                  <p>
                    Este caso está registrado como evento/incidente adverso serio. <br />
                    Recuerde que tiene menos de <strong>72 horas desde la ocurrencia del caso</strong> para completar y subir el {' '}
                    <a href="https://www.saludcapital.gov.co/SectorBelleza/Galeria%20de%20Descargas/Acreditaci%C3%B3n/Est%C3%A1ndares%20acreditaci%C3%B3n%20est%C3%A9tica/REPORTE%20EVENTOS%20SERIOS%20FOREIA001.pdf" target="_blank" rel="noopener noreferrer">
                      formato FOREIA001
                    </a>{' '}
                    a la plataforma del INVIMA.
                  </p>
                </div>
              }

            </div>
          ) : (
            <div>


              <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Editar caso de tecnovigilancia
                </Typography>
              </DialogTitle>

              <DialogContent>
                <form>
                  <Grid container spacing={2}>
                  <Grid item xs="12"><Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                     <Typography sx={{
                                         color: '#0468BF',
                                         fontSize: '18px',
                                         fontWeight: 400,
                                         ml: 1,
                                       }}>
                                         Información del Paciente (Opcional)
                                       </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box component="section" sx={{ width: '100%' }}>
  <Grid container spacing={2}>
    {/* Fila 1: Tipo de documento / Número */}
    <Grid item xs={12} sm={6}>
      <FormControl
        fullWidth
        size="small"
        error={Boolean(errors.tipoIdentificacion)}
      >
        <InputLabel id="tipoIdentificacion-label">Tipo de documento</InputLabel>
        <Select
          labelId="tipoIdentificacion-label"
          label="Tipo de documento"
          required
          name="tipoIdentificacion"
          id="tipoIdentificacion"
          value={this.state.tipoIdentificacion}
          onChange={this.handleChange}
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
          <MenuItem value="TI">Tarjeta de Identidad</MenuItem>
          <MenuItem value="RC">Registro Civil</MenuItem>
          <MenuItem value="PS">Pasaporte</MenuItem>
          <MenuItem value="CE">Cédula de Extranjería</MenuItem>
          <MenuItem value="MI">Menor sin Identificación</MenuItem>
          <MenuItem value="AI">Adulto sin Identificación</MenuItem>
          <MenuItem value="HC">Historia Clínica</MenuItem>
        </Select>
        <FormHelperText>{errors.tipoIdentificacion}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="number"
        name="numeroIdentificacion"
        id="numeroIdentificacion"
        label="Número de identificación"
        value={this.state.numeroIdentificacion}
        onChange={this.handleChange}
        helperText={errors.numeroIdentificacion}
        error={Boolean(errors.numeroIdentificacion)}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />
    </Grid>

    {/* Fila 2: Sexo / Edad / Edad en */}
    <Grid item xs={12} sm={6}>
      <FormControl
        fullWidth
        size="small"
        error={Boolean(errors.sexo)}
      >
        <InputLabel id="sexo-label">Sexo</InputLabel>
        <Select
          labelId="sexo-label"
          label="Sexo"
          required
          name="sexo"
          id="sexo"
          value={this.state.sexo}
          onChange={this.handleChange}
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          <MenuItem value="Femenino">Femenino</MenuItem>
          <MenuItem value="Masculino">Masculino</MenuItem>
          <MenuItem value="Sin dato">Sin dato</MenuItem>
        </Select>
        <FormHelperText>{errors.sexo}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="number"
        name="edad"
        id="edad"
        label="Edad"
        value={this.state.edad}
        onChange={this.handleChange}
        helperText={errors.edad}
        error={Boolean(errors.edad)}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl
        fullWidth
        size="small"
        error={Boolean(errors.edadEn)}
      >
        <InputLabel id="edadEn-label">Edad de la persona en</InputLabel>
        <Select
          labelId="edadEn-label"
          label="Edad de la persona en"
          required
          name="edadEn"
          id="edadEn"
          value={this.state.edadEn}
          onChange={this.handleChange}
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          <MenuItem value="días">Días</MenuItem>
          <MenuItem value="semanas">Semanas</MenuItem>
          <MenuItem value="meses">Meses</MenuItem>
          <MenuItem value="años">Años</MenuItem>
        </Select>
        <FormHelperText>{errors.edadEn}</FormHelperText>
      </FormControl>
    </Grid>

    {/* Fila 3: EPS */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="eps"
        id="eps"
        label="EPS del paciente"
        value={this.state.eps}
        onChange={this.handleChange}
        helperText={errors.eps}
        error={Boolean(errors.eps)}
        autoComplete="organization"
      />
    </Grid>

    {/* Fila 4: Diagnóstico (a lo ancho) */}
    <Grid item xs={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="diagnosticoInicialPaciente"
        id="diagnosticoInicialPaciente"
        label="Diagnóstico inicial del paciente"
        value={this.state.diagnosticoInicialPaciente}
        onChange={this.handleChange}
        helperText={errors.diagnosticoInicialPaciente}
        error={Boolean(errors.diagnosticoInicialPaciente)}
        multiline
        minRows={2}
      />
    </Grid>
  </Grid>
</Box>
                    </AccordionDetails>
                  </Accordion></Grid>

                  <Grid item xs="12"><Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >

                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Información del Equipo
                                        </Typography>
                      
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box component="section" sx={{ width: '100%' }}>
  <Grid container spacing={2}>
    {/* Nombre genérico / comercial */}
    <Grid item xs={12} sm={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="nombreGenericoDispositivo"
        id="nombreGenericoDispositivo"
        label="Nombre genérico del equipo"
        value={this.state.nombreGenericoDispositivo}
        onChange={this.handleChange}
        helperText={errors.nombreGenericoDispositivo}
        error={Boolean(errors.nombreGenericoDispositivo)}
        disabled
      />
    </Grid>

    <Grid item xs={12} sm={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="nombreComercialDispositivo"
        id="nombreComercialDispositivo"
        label="Nombre comercial del equipo"
        value={this.state.nombreComercialDispositivo}
        onChange={this.handleChange}
        helperText={errors.nombreComercialDispositivo}
        error={Boolean(errors.nombreComercialDispositivo)}
      />
    </Grid>

    {/* Registro Invima / Activo fijo */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="RegistroSanitario_PermisoComercializacion"
        id="RegistroSanitario_PermisoComercializacion"
        label="Registro Invima"
        value={this.state.RegistroSanitario_PermisoComercializacion}
        onChange={this.handleChange}
        helperText={errors.RegistroSanitario_PermisoComercializacion}
        error={Boolean(errors.RegistroSanitario_PermisoComercializacion)}
        disabled
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="activoFijo"
        id="activoFijo"
        label="Activo fijo del equipo"
        value={this.state.activoFijo}
        onChange={this.handleChange}
        helperText={errors.activoFijo}
        error={Boolean(errors.activoFijo)}
        disabled
      />
    </Grid>

    {/* Lote / Modelo */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="text"
        name="lote"
        id="lote"
        label="Lote"
        value={this.state.lote}
        onChange={this.handleChange}
        helperText={errors.lote}
        error={Boolean(errors.lote)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="modelo"
        id="modelo"
        label="Modelo"
        value={this.state.modelo}
        onChange={this.handleChange}
        helperText={errors.modelo}
        error={Boolean(errors.modelo)}
        disabled
      />
    </Grid>

    {/* Referencia / Serie */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="text"
        name="referencia"
        id="referencia"
        label="Referencia"
        value={this.state.referencia}
        onChange={this.handleChange}
        helperText={errors.referencia}
        error={Boolean(errors.referencia)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="serie"
        id="serie"
        label="Serie"
        value={this.state.serie}
        onChange={this.handleChange}
        helperText={errors.serie}
        error={Boolean(errors.serie)}
        disabled
      />
    </Grid>

    {/* Marca / Importador */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="marca"
        id="marca"
        label="Razón social del fabricante"
        value={this.state.marca}
        onChange={this.handleChange}
        helperText={errors.marca}
        error={Boolean(errors.marca)}
        disabled
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="importadorDistribuidor"
        id="importadorDistribuidor"
        label="Importador/distribuidor"
        value={this.state.importadorDistribuidor}
        onChange={this.handleChange}
        helperText={errors.importadorDistribuidor}
        error={Boolean(errors.importadorDistribuidor)}
        disabled
      />
    </Grid>

    {/* Servicio / Ubicación */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="servicio"
        id="servicio"
        label="Servicio"
        value={this.state.servicio}
        onChange={this.handleChange}
        helperText={errors.servicio}
        error={Boolean(errors.servicio)}
        autoComplete="section-dept"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="ubicacion"
        id="ubicacion"
        label="Ubicación"
        value={this.state.ubicacion}
        onChange={this.handleChange}
        helperText={errors.ubicacion}
        error={Boolean(errors.ubicacion)}
        autoComplete="section-room"
      />
    </Grid>

    {/* ¿Más de un uso? */}
    <Grid item xs={12} sm={12}>
      <FormControl
        fullWidth
        size="small"
        error={Boolean(errors.masDeUnUso)}
      >
        <InputLabel id="masDeUnUso-label">¿Se ha usado más de una vez?</InputLabel>
        <Select
          labelId="masDeUnUso-label"
          label="¿Se ha usado más de una vez?"
          required
          name="masDeUnUso"
          id="masDeUnUso"
          value={this.state.masDeUnUso}
          onChange={this.handleChange}
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          <MenuItem value="Si">Sí</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
        <FormHelperText>{errors.masDeUnUso}</FormHelperText>
      </FormControl>
    </Grid>
  </Grid>
</Box>
                    </AccordionDetails>
                  </Accordion></Grid>

                  <Grid item xs="12"><Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Clasificación del Caso
                                        </Typography>
                                   </AccordionSummary>
                    <AccordionDetails>
                     <Box component="section" sx={{ width: '100%' }}>
  <Grid container spacing={2}>
    {/* Fechas */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="date"
        name="fechaDelEvento"
        id="fechaDelEvento"
        label="Fecha de ocurrencia del evento"
        value={this.state.fechaDelEvento}
        onChange={this.handleChange}
        helperText={errors.fechaDelEvento}
        error={Boolean(errors.fechaDelEvento)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format('YYYY-MM-DD') }}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="date"
        name="fechaReporte"
        id="fechaReporte"
        label="Fecha del reporte"
        value={this.state.fechaReporte}
        onChange={this.handleChange}
        helperText={errors.fechaReporte}
        error={Boolean(errors.fechaReporte)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format('YYYY-MM-DD') }}
        disabled
      />
    </Grid>

    {/* Detección del caso / Clasificación */}
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.momentoDeteccion)}>
        <InputLabel id="momentoDeteccion-label">Detección del caso</InputLabel>
        <Select
          labelId="momentoDeteccion-label"
          label="Detección del caso"
          required
          name="momentoDeteccion"
          id="momentoDeteccion"
          value={this.state.momentoDeteccion}
          onChange={this.handleChange}
          disabled
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Antes del uso del DM">Antes de utilizarlo</MenuItem>
          <MenuItem value="Durante el uso del DM">Durante el uso</MenuItem>
          <MenuItem value="Después del uso del DM">Después de utilizarlo</MenuItem>
        </Select>
        <FormHelperText>{errors.momentoDeteccion}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.clasificacionCaso)}>
        <InputLabel id="clasificacionCaso-label">Clasificación</InputLabel>
        <Select
          labelId="clasificacionCaso-label"
          label="Clasificación"
          required
          name="clasificacionCaso"
          id="clasificacionCaso"
          value={this.state.clasificacionCaso}
          onChange={this.handleChange}
          disabled
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Evento adverso serio">Evento adverso serio</MenuItem>
          <MenuItem value="Evento adverso no serio">Evento adverso no serio</MenuItem>
          <MenuItem value="Incidente adverso serio">Incidente adverso serio</MenuItem>
          <MenuItem value="Incidente adverso no serio">Incidente adverso no serio</MenuItem>
        </Select>
        <FormHelperText>{errors.clasificacionCaso}</FormHelperText>
      </FormControl>
    </Grid>

    {/* Desenlace / Otro */}
    <Grid item xs={12} sm={12}>
      <FormControl fullWidth size="small" error={Boolean(errors.desenlaceCaso)}>
        <InputLabel id="desenlaceCaso-label">Desenlace del caso</InputLabel>
        <Select
          labelId="desenlaceCaso-label"
          label="Desenlace del caso"
          required
          name="desenlaceCaso"
          id="desenlaceCaso"
          value={this.state.desenlaceCaso}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Murio">Murió</MenuItem>
          <MenuItem value="Daño de una función o estructura corporal">Daño de una función o estructura corporal</MenuItem>
          <MenuItem value="Enfermedad o daño que amenace la vida">Enfermedad o daño que amenace la vida</MenuItem>
          <MenuItem value="Requiere intervención médica o quirúrgica, para prevenir un daño permanente de una estructura o función corporal">
            Requiere intervención médica o quirúrgica, para prevenir un daño permanente de una estructura o función corporal
          </MenuItem>
          <MenuItem value="Hospitalización inicial o prolongada">Hospitalización inicial o prolongada</MenuItem>
          <MenuItem value="No hubo daño">No hubo daño</MenuItem>
          <MenuItem value="Otro">Otro</MenuItem>
        </Select>
        <FormHelperText>{errors.desenlaceCaso}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="otro"
        id="otro"
        label="¿Otro? Especifique"
        value={this.state.otro}
        onChange={this.handleChange}
        helperText={errors.otro}
        error={Boolean(errors.otro)}
        disabled={this.state.desenlaceCaso === 'Otro' ? false : true}
      />
    </Grid>

    {/* Descripción (a lo ancho) */}
    <Grid item xs={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="descripcionCaso"
        id="descripcionCaso"
        label="Descripción del caso"
        value={this.state.descripcionCaso}
        onChange={this.handleChange}
        helperText={errors.descripcionCaso}
        error={Boolean(errors.descripcionCaso)}
        multiline
        minRows={3}
      />
    </Grid>
  </Grid>
</Box>

                    </AccordionDetails>
                  </Accordion></Grid>

                  <Grid item xs="12"><Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Gestión Realizada
                                        </Typography>
                      </AccordionSummary>

                    <AccordionDetails>
                    <Box component="section" sx={{ width: '100%' }}>
  <Grid container spacing={2}>
    {/* Causa probable */}
    <Grid item xs={12} sm={12}>
      <FormControl fullWidth size="small" error={Boolean(errors.causaCaso)}>
        <InputLabel id="causaCaso-label">Causa probable del caso</InputLabel>
        <Select
          labelId="causaCaso-label"
          label="Causa probable del caso"
          required
          name="causaCaso"
          id="causaCaso"
          value={this.state.causaCaso}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Uso anormal">Uso anormal</MenuItem>
          <MenuItem value="Respuesta fisiológica anormal o inesperada">Respuesta fisiológica anormal o inesperada</MenuItem>
          <MenuItem value="Falla en la alarma">Falla en la alarma</MenuItem>
          <MenuItem value="Uso de material biológico">Uso de material biológico</MenuItem>
          <MenuItem value="Calibración">Calibración</MenuItem>
          <MenuItem value="Hardware del computador">Hardware del computador</MenuItem>
          <MenuItem value="Contaminación durante la producción">Contaminación durante la producción</MenuItem>
          <MenuItem value="Contaminación post-producción">Contaminación post-producción</MenuItem>
          <MenuItem value="Diseño">Diseño</MenuItem>
          <MenuItem value="Desconexión">Desconexión</MenuItem>
          <MenuItem value="Componente eléctrico">Componente eléctrico</MenuItem>
          <MenuItem value="Circuito eléctrico">Circuito eléctrico</MenuItem>
          <MenuItem value="Contacto eléctrico">Contacto eléctrico</MenuItem>
          <MenuItem value="Condiciones no higiénicas">Condiciones no higiénicas</MenuItem>
          <MenuItem value="No relacionado con el dispositivo">No relacionado con el dispositivo</MenuItem>
          <MenuItem value="Otros">Otros</MenuItem>
          <MenuItem value="Empaque">Empaque</MenuItem>
          <MenuItem value="Anatomía/Fisiología del paciente">Anatomía/Fisiología del paciente</MenuItem>
          <MenuItem value="Condición del paciente">Condición del paciente</MenuItem>
          <MenuItem value="Fuente de energía">Fuente de energía</MenuItem>
          <MenuItem value="Medidas de protección">Medidas de protección</MenuItem>
          <MenuItem value="Aseguramiento  de la calidad en la institución para la atención en salud">
            Aseguramiento  de la calidad en la institución para la atención en salud
          </MenuItem>
          <MenuItem value="Radiación">Radiación</MenuItem>
          <MenuItem value="Software">Software</MenuItem>
          <MenuItem value="Esterilización/desinfección/ limpieza">Esterilización/desinfección/ limpieza</MenuItem>
          <MenuItem value="Condiciones de almacenamiento">Condiciones de almacenamiento</MenuItem>
          <MenuItem value="Alteración/falsificación/ sabotaje">Alteración/falsificación/ sabotaje</MenuItem>
          <MenuItem value="Entrenamiento">Entrenamiento</MenuItem>
          <MenuItem value="Transporte y entrega">Transporte y entrega</MenuItem>
          <MenuItem value="Sin identificar">Sin identificar</MenuItem>
          <MenuItem value="Capacidad de Uso">Capacidad de Uso</MenuItem>
          <MenuItem value="Error de Uso">Error de Uso</MenuItem>
          <MenuItem value="Desgaste">Desgaste</MenuItem>
        </Select>
        <FormHelperText>{errors.causaCaso}</FormHelperText>
      </FormControl>
    </Grid>

    {/* Acciones correctivas/preventivas */}
    <Grid item xs={12} sm={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="accionTomada"
        id="accionTomada"
        label="Acciones correctivas y preventivas iniciadas"
        value={this.state.accionTomada}
        onChange={this.handleChange}
        helperText={errors.accionTomada}
        error={Boolean(errors.accionTomada)}
      />
    </Grid>

    {/* ¿Reportó al distribuidor? / Fecha reporte */}
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.reporteDistibuidor)}>
        <InputLabel id="reporteDistibuidor-label">¿Reportó al distribuidor?</InputLabel>
        <Select
          labelId="reporteDistibuidor-label"
          label="¿Reportó al distribuidor?"
          required
          name="reporteDistibuidor"
          id="reporteDistibuidor"
          value={this.state.reporteDistibuidor}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Si">Sí</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
        <FormHelperText>{errors.reporteDistibuidor}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="date"
        name="fechaReporteDistribuidor"
        id="fechaReporteDistribuidor"
        label="Fecha de reporte al distribuidor"
        value={this.state.fechaReporteDistribuidor}
        onChange={this.handleChange}
        helperText={errors.fechaReporteDistribuidor}
        error={Boolean(errors.fechaReporteDistribuidor)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format('YYYY-MM-DD') }}
        disabled={this.state.reporteDistibuidor === 'Si' ? false : true}
      />
    </Grid>

    {/* ¿Se envió al distribuidor? / Fecha envío */}
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.envioDistribuidor)}>
        <InputLabel id="envioDistribuidor-label">¿Se envió al distribuidor?</InputLabel>
        <Select
          labelId="envioDistribuidor-label"
          label="¿Se envió al distribuidor?"
          required
          name="envioDistribuidor"
          id="envioDistribuidor"
          value={this.state.envioDistribuidor}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Si">Sí</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
        <FormHelperText>{errors.envioDistribuidor}</FormHelperText>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="date"
        name="fechaEnvioDistribuidor"
        id="fechaEnvioDistribuidor"
        label="Fecha de envio al distribuidor"
        value={this.state.fechaEnvioDistribuidor}
        onChange={this.handleChange}
        helperText={errors.fechaEnvioDistribuidor}
        error={Boolean(errors.fechaEnvioDistribuidor)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: moment().format('YYYY-MM-DD') }}
        disabled={this.state.envioDistribuidor === 'Si' ? false : true}
      />
    </Grid>

    {/* ¿Disponible para evaluación? */}
    <Grid item xs={12} sm={12}>
      <FormControl fullWidth size="small" error={Boolean(errors.disponibleEvaluacion)}>
        <InputLabel id="disponibleEvaluacion-label">¿Disponible para evaluación?</InputLabel>
        <Select
          labelId="disponibleEvaluacion-label"
          label="¿Disponible para evaluación?"
          required
          name="disponibleEvaluacion"
          id="disponibleEvaluacion"
          value={this.state.disponibleEvaluacion}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="Si">Sí</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
        <FormHelperText>{errors.disponibleEvaluacion}</FormHelperText>
      </FormControl>
    </Grid>
  </Grid>
</Box>
                    </AccordionDetails>
                  </Accordion></Grid>

                  <Grid item xs="12"><Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Información del Reportante
                                        </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Box component="section" sx={{ width: '100%' }}>
  <Grid container spacing={2}>
    {/* Nombre del reportante (ancho completo) */}
    <Grid item xs={12}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="nombreReportante"
        id="nombreReportante"
        label="Nombres y apellidos completos del reportante"
        value={this.state.nombreReportante}
        onChange={this.handleChange}
        helperText={errors.nombreReportante}
        error={Boolean(errors.nombreReportante)}
        autoComplete="name"
      />
    </Grid>

    {/* Profesión / Área o servicio */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="profesion"
        id="profesion"
        label="Profesión"
        value={this.state.profesion}
        onChange={this.handleChange}
        helperText={errors.profesion}
        error={Boolean(errors.profesion)}
        autoComplete="organization-title"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        required
        type="text"
        name="servicioPerteneciente"
        id="servicioPerteneciente"
        label="Área o servicio al que pertenece"
        value={this.state.servicioPerteneciente}
        onChange={this.handleChange}
        helperText={errors.servicioPerteneciente}
        error={Boolean(errors.servicioPerteneciente)}
        autoComplete="section-dept"
      />
    </Grid>

    {/* Dirección / Teléfono */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="text"
        name="direccion"
        id="direccion"
        label="Dirección"
        value={this.state.direccion}
        onChange={this.handleChange}
        helperText={errors.direccion}
        error={Boolean(errors.direccion)}
        autoComplete="street-address"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="text"
        name="telefono"
        id="telefono"
        label="Teléfono"
        value={this.state.telefono}
        onChange={this.handleChange}
        helperText={errors.telefono}
        error={Boolean(errors.telefono)}
        inputProps={{ inputMode: 'tel' }}
        autoComplete="tel"
      />
    </Grid>

    {/* Correo / Estado del caso */}
    <Grid item xs={12} sm={6}>
      <TextField
        size="small"
        fullWidth
        type="text"
        name="correoInstitucional"
        id="correoInstitucional"
        label="Correo institucional"
        value={this.state.correoInstitucional}
        onChange={this.handleChange}
        helperText={errors.correoInstitucional}
        error={Boolean(errors.correoInstitucional)}
        autoComplete="email"
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <FormControl fullWidth size="small" error={Boolean(errors.estadoReporte)}>
        <InputLabel id="estadoReporte-label">Estado del caso</InputLabel>
        <Select
          labelId="estadoReporte-label"
          label="Estado del caso"
          required
          name="estadoReporte"
          id="estadoReporte"
          value={this.state.estadoReporte}
          onChange={this.handleChange}
        >
          <MenuItem value=""><em></em></MenuItem>
          <MenuItem value="A">Abierto</MenuItem>
          <MenuItem value="S">En seguimiento</MenuItem>
          <MenuItem value="C">Cerrado</MenuItem>
        </Select>
        <FormHelperText>{errors.estadoReporte}</FormHelperText>
      </FormControl>
    </Grid>
  </Grid>
</Box>
                    </AccordionDetails>
                  </Accordion></Grid>
                  </Grid>

                  {Object.keys(errors).length > 0 && (
                    <p>Por favor, diligencie todos los campos mínimamente obligatorios para crear un caso</p>
                  )}

                </form>
              </DialogContent>
            </div>
          )
          }
          <DialogActions>
            {this.props.UI.loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              <Box>
                <Tooltip title="Cerrar">
                  <IconButton onClick={this.handleCloseEdit} size="small">
                    <FaArrowLeft color="#D3D7DC" />
                  </IconButton>
                </Tooltip>
                {this.state.aprobado.mensaje ? (
                  <></>
                ) : (
                  <Tooltip title="Confirmar edición">
                    <IconButton onClick={this.handleEdit} size="small">
                      <FaEdit color="#03178C" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>

            )}
          </DialogActions>
        </Dialog>


        {
          // Eliminar reporte
        }
        <Dialog
          open={this.state.openDelete}
          onClose={this.handleCloseDelete}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {this.state.aprobado.mensaje ? (
              <></>
            ) : (
              <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                Confirmación para eliminar caso de tecnovigilancia
              </Typography>
            )}
          </DialogTitle>
          <DialogContent>
            {this.state.aprobado.mensaje ? (
              <div className='div-aprobado'>
                <div className='div-icono-aprobado'>
                  <FaCheck color="#ffffff" className='icono-aprobado' />
                </div>
                <h2 className='text-aprobado'>!Caso eliminado exitosamente¡</h2>
              </div>
            ) : (
              <p>¿Estás seguro que deseas eliminar este caso? <br /><br />
                Recuerde que la tecnovigilancia es un proceso proactivo y en conjunto con los demás usuarios del dispositivo médico.
                Así desde Alpha Biomédica, te recordamos que todos los usuarios que tengan que ver con este equipo pueden ver o
                editar este reporte, y al eliminarlo de la base de datos puede que se pierda parte importante de la trazabilidad del equipo.
              </p>
            )}
          </DialogContent>
          <DialogActions>
            {this.props.UI.loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              <Box>
                <Tooltip title="Cerrar">
                  <IconButton onClick={this.handleCloseDelete} size="small">
                    <FaArrowLeft color="#D3D7DC" />
                  </IconButton>
                </Tooltip>
                {this.state.aprobado.mensaje ? (
                  <></>
                ) : (
                  <Tooltip title="Confirmar">
                    <IconButton onClick={this.handleDelete} size="small">
                      <FaTrashAlt color="#03178C" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          </DialogActions>
        </Dialog>
      </Box >
    )
  }
}

TablaTecno.propTypes = {
  getCasosTecnoEquipo: PropTypes.func.isRequired,
  deleteCasoTecno: PropTypes.func.isRequired,
  editCasoTecno: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,

  data: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapActionsToProps = {
  getCasosTecnoEquipo,
  deleteCasoTecno,
  editCasoTecno,
  clearErrors
};

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI,
  usuario: state.user.credentials
})



export default connect(mapStateToProps, mapActionsToProps)(TablaTecno);